<template>
    <div class="app">
        <AppHeader />
        <div class="app-body">
            <main class="main h-100">
                <router-view :key="$route.path"></router-view>
            </main>
        </div>
    </div>
</template>

<script>
import { Header as AppHeader } from '../components/';

export default {
    name: 'full',
    components: {
        AppHeader
    }
};
</script>
